import React from 'react';

import toSafeInteger from 'lodash/toSafeInteger';
import { connect } from 'react-redux';
import type { State } from 'state';
import { getProjectId } from 'state/selectors/portal';

// eslint-disable-next-line no-restricted-imports
import { JiraProjectAri } from '@atlassian/ari';
import { RovoServiceAgentWidgetInjector } from '@atlassian/rovo-service-agent-chat-widget';

/**
 * Corner widget for a portal-scoped hub route, loaded against the portal's own container.
 *
 * Renders nothing until `projectId` resolves, which is deliberate: `loadRovoWidgetSDKScript`
 * memoises the first `widgetId` it is given on a module-level promise, so rendering with the help
 * center as a placeholder would lock the widget to the hub's agent and silently ignore the portal
 * container once redux caught up.
 */
export const PortalRovoWidgetDumb = ({
	cloudId,
	projectId,
}: {
	cloudId: string;
	projectId: number | undefined;
}) => {
	if (!projectId) {
		return null;
	}

	return (
		<RovoServiceAgentWidgetInjector
			siteId={cloudId}
			widgetId={JiraProjectAri.create({
				projectId: projectId.toString(),
				siteId: cloudId,
			}).toString()}
			surface="HUB"
		/>
	);
};

export const PortalRovoWidget = connect((state: State, { portalId }: { portalId: string }) => ({
	// `toSafeInteger` directly rather than `getPortalIdAsNumber` from `view/search/common`: that
	// barrel pulls in analytics-components -> history -> getMeta, which blows up at import time.
	projectId: getProjectId(state, toSafeInteger(portalId)),
}))(PortalRovoWidgetDumb);
